import { usePage } from '@inertiajs/react';
import { useEffect, useRef } from 'react';
import { toast } from '@/lib/toast';

// Rails flash (notice / alert) arrives on the Inertia page object
// (InertiaRails flash_keys); each flash is shown once. Compared by content,
// not identity: a page's deferred props merge into it after the redirect and
// hand back the same flash as a new object, which used to toast it twice.
// A visit without a flash clears the memory, so the same notice from the
// next save still shows.
export function useFlashToasts(): void {
  const { flash } = usePage();
  const shown = useRef<string | null>(null);

  useEffect(() => {
    const notice = flash?.notice ?? null;
    const alert = flash?.alert ?? null;
    if (!notice && !alert) {
      shown.current = null;
      return;
    }
    const key = JSON.stringify([notice, alert]);
    if (shown.current === key) return;
    shown.current = key;
    if (notice) toast.success(notice);
    if (alert) toast.error(alert);
  }, [flash]);
}
